import api from "./api";

export async function getMedications() {
  try {
    const res = await api.get(`medication`);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function createMedication(payload) {
  try {
    const res = await api.post(`medication`, payload);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function administerMedication(payload,serviceUserId) {
  try {
    const res = await api.post(
      `shifts/${payload.shiftId}/service-users/${serviceUserId}/administered-medications`,
      payload
    );
    return res;
  } catch (err) {
    throw err;
  }
}

export async function updateAdministeredMedication(payload,serviceUserId) {
  try {
    const res = await api.put(
      `shifts/${payload.shiftId}/service-users/${serviceUserId}/administered-medications`,
      payload
    );
    return res;
  } catch (err) {
    throw err;
  }
}

export async function getAdministeredMedication(shiftId,serviceUserId) {
  try {
    const res = await api.get(`shifts/${shiftId}/service-users/${serviceUserId}/administered-medications`);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function getAdministeredPRNMedications(shiftId,serviceUserId) {
  try {
    const res = await api.get(`shifts/${shiftId}/service-users/${serviceUserId}/administered-prn-medications`);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function administerPRNMedication(payload) {
  try {
    const res = await api.post(
      `shifts/${payload.shiftId}/service-users/${payload.serviceUserId}/administered-prn-medications`,
      payload
    );
    return res;
  } catch (err) {
    throw err;
  }
}

export async function upsertAdministeredPRNMedication(payload) {
  try {
    const res = await api.put(
      `shifts/${payload.shiftId}/service-users/${payload.serviceUserId}/administered-prn-medications`,
      payload
    );
    return res;
  } catch (err) {
    throw err;
  }
}

export async function deleteMedicationItem(userId, groupId, itemId) {
  if (!userId || !groupId || !itemId) {
    throw new Error("Missing required parameters: userId, groupId, and itemId are required");
  }

  try {
    const res = await api.delete(`serviceusers/${userId}/medication-groups/${groupId}/items/${itemId}`);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function deleteMedicationGroup(userId, groupId) {
  if (!userId || !groupId) {
    throw new Error("Missing required parameters: userId and groupId are required");
  }

  try {
    const res = await api.delete(`serviceusers/${userId}/medication-groups/group/${groupId}`);
    return res;
  } catch (err) {
    throw err;
  }
}
